import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const MenuIcon = ({ className }) => {
  return /* @__PURE__ */ jsxs("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    className: clsx("new_icon", className),
    children: [
      /* @__PURE__ */ jsx("rect", {
        width: "16",
        height: "2",
        rx: "1",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("rect", {
        y: "5",
        width: "16",
        height: "2",
        rx: "1",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("rect", {
        y: "10",
        width: "16",
        height: "2",
        rx: "1",
        fill: "currentColor"
      })
    ]
  });
};

export { MenuIcon as default };
//# sourceMappingURL=MenuIcon.js.map
